import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_HEALTH_DASHBOARD_MAC_OS_PERMISSIONS } from '../../../../webcomponents.constants';
import { GzHealthDashboardInsights } from './GzHealthDashboardInsights';
import { HealthDashboardMacOsStrings, InsightsTemplatesStringKeys } from '../types';
import { translateFn } from '../../../../utils/translator.helper';
import { html, TemplateResult } from 'lit';
import { WidgetSectionItemSeverity } from '../../../../ui/gzWidgetSectionItem/types';

@customElement(WEB_COMPONENT_HEALTH_DASHBOARD_MAC_OS_PERMISSIONS)
export class GzHealthDashboardMacOsPermissionsWebComponent extends GzHealthDashboardInsights {
  widgetKey = 'macOsPermissionIssues';

  changedInfoBoxHasPadding = true;

  changedInfoBoxText = `
    <gz-tooltip
      isEllipsis
      class="two-line-tooltip"
      tooltipText="${translateFn('You have <b>updates</b> for this widget!')}"
    >
      ${translateFn('You have <b>updates</b> for this widget!')}
    </gz-tooltip>
    <br />
    <br />
    <gz-tooltip
      isEllipsis
      class="four-line-tooltip"
      tooltipText="${translateFn(
        'To experience the latest design, close the current widget and select the new ones in the Settings panel. Apply your changes and save the view.'
      )}"
    >
      ${translateFn(
        'To experience the latest design, close the current widget and select the new ones in the Settings panel. Apply your changes and save the view.'
      )}
    </gz-tooltip>`;

  strings: HealthDashboardMacOsStrings = {
    sections: [
      {
        key: InsightsTemplatesStringKeys.MAC_OS_PERMISSION_ISSUES,
        items: [
          {
            key: InsightsTemplatesStringKeys.KERNEL_EXTENSION_NOT_APPROVED,
            name: translateFn('System extensions not allowed'),
            severity: WidgetSectionItemSeverity.WARNING,
            tooltipText: translateFn(
              'Endpoints require permission to install system extensions. Allow extensions in Security & Privacy preferences and restart your system.'
            ),
          },
          {
            key: InsightsTemplatesStringKeys.DISK_ACCESS_NOT_GRANTED,
            name: translateFn('Full Disk Access not allowed'),
            severity: WidgetSectionItemSeverity.WARNING,
            tooltipText: translateFn(
              'Endpoints require Full Disk Access for certain modules to function properly. Open Privacy settings and grant Full Disk Access.'
            ),
          },
          {
            key: InsightsTemplatesStringKeys.NETWORK_EXTENSION_NOT_INSTALLED,
            name: translateFn('Network extension not allowed'),
            severity: WidgetSectionItemSeverity.WARNING,
            tooltipText: translateFn('Endpoints require network extensions to be enabled.'),
          },
          {
            key: InsightsTemplatesStringKeys.TUNNELING_APPLICATION_NOT_ALLOWED,
            name: translateFn('Tunneling application not allowed'),
            severity: WidgetSectionItemSeverity.WARNING,
            tooltipText: translateFn(
              'Endpoints require a proxy configuration. Allow BDLdaemon application to add proxy configuration.'
            ),
          },
          {
            key: InsightsTemplatesStringKeys.CERTIFICATE_SSL_NOT_TRUSTED,
            name: translateFn('SSL certificate not allowed'),
            severity: WidgetSectionItemSeverity.WARNING,
            tooltipText: translateFn(
              'Bitdefender root certificate may not be installed, trusted or its installation failed on endpoints.'
            ),
          },
        ],
      },
    ],
  };

  protected renderHeader(): TemplateResult | undefined {
    return;
  }

  protected renderLoader(): TemplateResult {
    return html`
      <div class="loading-container pt-3">
        ${this.strings?.sections.map(section => this.renderSectionLoader(section))}
      </div>
    `;
  }
}
